import React from 'react';
import { MenuItem as ChakraMenuItem, MenuItemProps as ChakraMenuItemProps } from '@chakra-ui/react';

export function MenuItem(props: ChakraMenuItemProps) {
  return <ChakraMenuItem {...props} />;
}
